import { colors } from '../colors';

export const semanticPalette = {
    primary: colors.blue[500],
    success: colors.green[500],
    // The design is very monochromatic; therefore, you can have surface50 on top of surface200
    'surface-50': colors.bluegray[50],
    'surface-100': colors.bluegray[100],
    'surface-200': colors.bluegray[200],
    'surface-800': colors.bluegray[800],
    white: colors.white,
};

export const semanticPaletteMap = Object.fromEntries(Object.keys(semanticPalette).map((key) => [key, key])) as {
    [K in keyof typeof semanticPalette]: K;
};

export const borderColors = {
    transparent: 'transparent',
    'bluegray-100': colors.bluegray[100],
    'bluegray-200': colors.bluegray[200],
    'bluegray-300': colors.bluegray[300],
    'bluegray-400': colors.bluegray[400],
    primary: colors.blue[500],
};
export const borderColorsMap = Object.fromEntries(Object.keys(borderColors).map((key) => [key, key])) as {
    [K in keyof typeof borderColors]: K;
};

export const textColors = {
    primary: colors.bluegray[600],
    strong: colors.bluegray[700],
    inverse: colors.white,
    brand: colors.blue[500],
    success: colors.green[500],
    successLight: colors.green[400],
    warning: colors.yellow[500],
    danger: colors.red[500],
    inherit: 'inherit',
    muted: colors.bluegray[400],
    light: colors.bluegray[50],
};

export const textColorsMap = Object.fromEntries(Object.keys(textColors).map((key) => [key, key])) as {
    [K in keyof typeof textColors]: K;
};
